import Pacientes from '@/models/pacientes/Pacientes';
import http from './ApiConfig';
import { Service } from './Service';

export class PacientesService extends Service {
  constructor() {
    super('pacientes');
  }

  public GetAllPaginado(
    valorFiltro: string,
    filtroSituacaoPaciente: number,
    listarSomentePacientesComAtendimento: boolean,
    limit: number,
    page: number,
    situacaoCadastro?: number,
  ) {
    const params = new URLSearchParams();
    params.append('filtroSituacaoPaciente', filtroSituacaoPaciente.toString());
    params.append('listarSomentePacientesComAtendimento', listarSomentePacientesComAtendimento.toString());
    params.append('limit', limit.toString());
    params.append('page', page.toString());

    if (valorFiltro) {
      params.append('valorFiltro', valorFiltro);
    }
    if (situacaoCadastro !== undefined && situacaoCadastro !== null && [0, 1, 2].includes(situacaoCadastro)) {
      params.append('situacaoCadastro', situacaoCadastro.toString());
    }

    return http.get(`${this._nomeControle}?${params.toString()}`, this.GetHeader());
  }

  public BuscarPaciente() {
    return http.get(`${this._nomeControle}/buscar`, this.GetHeader());
  }

  public AtivarPaciente(pacienteId: number) {
    return http.patch(`${this._nomeControle}/${pacienteId}/ativar`, this.GetHeader());
  }

  public InativarPaciente(pacienteId: number) {
    return http.patch(`${this._nomeControle}/${pacienteId}/inativar`, this.GetHeader());
  }

  public ObterPendenciasInativacao(pacienteId: number) {
    return http.get(`${this._nomeControle}/${pacienteId}/pendencias-inativacao`, this.GetHeader());
  }

  public InativarPacienteComTratamento(pacienteId: number) {
    return http.patch(`${this._nomeControle}/${pacienteId}/inativar-com-tratamento`, this.GetHeader());
  }

  public ObterDadosDoPaciente(pacienteId: number): Promise<Pacientes> {
    return http.get(`${this._nomeControle}/${pacienteId}`, this.GetHeader());
  }

  public BuscarPacientePorIdComConvenios(pacienteId: number): Promise<Pacientes> {
    return http.get(`${this._nomeControle}/buscar-com-filtros/${pacienteId}`, this.GetHeader());
  }

  public MarcarQueOPacienteTemAtendimento(pacienteId: number) {
    return http.patch(`${this._nomeControle}/${pacienteId}/temAtendimento`, this.GetHeader());
  }

  public async getTotaisPacientes(): Promise<{ ativos: number; inativos: number }> {
    try {
      const response = await http.get(`${this._nomeControle}/totais`, this.GetHeader());
      return response.data;
    } catch (error) {
      console.error('Erro ao obter totais de pacientes:', error);
      throw error;
    }
  }
}
